<template>
    <div>
        <div v-if="errors.length > 0" class="tw-w-full tw-mb-4 tw-text-danger-primary">
            <div v-for="error in errors">
                {{ error }}
            </div>
        </div>
        <div class="tw-flex tw-w-full tw-gap-4">
            <div class="tw-w-1/2 tw-space-y-4">
                <div class="cu-panel">
                    <div class="cu-panel-header">Allgemeine Informationen</div>
                    <div class="cu-panel-body tw-space-y-3">
                        <strong>Bewerbung</strong>
                        <bordered-input>
                            <template #label>
                                <label for="subject">Betreff</label>
                            </template>
                            <template #input>
                                <input @input="dirtyApplication()" type="text" id="subject" v-model="applicationFront.subject">
                            </template>
                        </bordered-input>
                        <bordered-input>
                            <template #label>
                                <label for="application_name">Name</label>
                            </template>
                            <template #input>
                                <input @input="dirtyApplication()" type="text" id="application_name" v-model="applicationFront.from_name">
                            </template>
                        </bordered-input>
                        <bordered-input>
                            <template #label>
                                <label for="application_email">E-Mail</label>
                            </template>
                            <template #input>
                                <input @input="dirtyApplication()" type="email" id="application_email" v-model="applicationFront.from_email">
                            </template>
                        </bordered-input>
                        <bordered-input>
                            <template #label>
                                <label for="to_be_rejected_date">Ablehn-Datum</label>
                            </template>
                            <template #input>
                                <input @input="dirtyApplication()" type="date" id="to_be_rejected_date" v-model="applicationFront.to_be_rejected_date">
                            </template>
                        </bordered-input>

                        <div v-if="applicationDirtyFlag" class="tw-flex tw-gap-2">
                            <button @click="saveApplication()" class="cu-btn">Speichern</button>
                            <button @click="abortApplicationEdit()" class="cu-btn-default">Abbrechen</button>
                        </div>

                        <hr class="tw-my-8">

                        <strong>Bewerber</strong>
                        <bordered-input>
                            <template #label>
                                <label for="applicant_name">Name</label>
                            </template>
                            <template #input>
                                <input @input="dirtyApplicant()" type="text" id="applicant_name" v-model="applicantFront.name">
                            </template>
                        </bordered-input>
                        <bordered-input>
                            <template #label>
                                <label for="applicant_email">E-Mail</label>
                            </template>
                            <template #input>
                                <input @input="dirtyApplicant()" type="text" id="applicant_email" v-model="applicantFront.email">
                            </template>
                        </bordered-input>
                        <bordered-input>
                            <template #label>
                                <label for="applicant_sex">Geschlecht</label>
                            </template>
                            <template #input>
                                <select @change="dirtyApplicant()" v-model="applicantFront.sex">
                                    <option :value="null" :required="applicantFront.sex == null ? true : false">Nicht angegeben</option>
                                    <option value="male" :required="applicantFront.sex == 'male' ? true : false">Herr</option>
                                    <option value="female" :required="applicantFront.sex == 'female' ? true : false">Frau</option>
                                </select>
                            </template>
                        </bordered-input>

                        <div v-if="applicantDirtyFlag" class="tw-flex tw-gap-2">
                            <button @click="saveApplicant()" class="cu-btn">Speichern</button>
                            <button @click="abortApplicantEdit()" class="cu-btn-default">Abbrechen</button>
                        </div>

                        <div v-if="otherApplications.length == 0">
                            Dieser Bewerber ist ausschließlich dieser Bewerbung zugeordnet.
                        </div>
                        <div v-else>
                            <strong>Diesem Bewerber zugeordnete andere Bewerbungen:</strong>
                            <a class="cu-link tw-block" v-for="other in otherApplications" :href="'/applications/admin/edit/' + other.id">
                                {{ other.subject }}
                            </a>
                            <a class="tw-mt-4 cu-btn" :href="'/applications/admin/api/create-applicant/' + applicationFront.id"><i class="fa fa-user tw-mr-2"></i>Neuen Bewerber für diese Bewerbung anlegen</a>
                        </div>
                    </div>
                </div>
            
                <div class="cu-panel">
                    <div class="cu-panel-header">Erinnerungen</div>
                    <div class="cu-panel-body tw-space-y-6">
                        <div v-for="(reminder, index) in remindersFront" class="tw-space-y-3">
                            <div class="tw-flex tw-gap-2">
                                <bordered-input>
                                    <template #label>
                                        <label :for="'reminder_' + reminder.id + '_type'">Typ</label>
                                    </template>
                                    <template #input>
                                        <select @change="dirtyReminders()" v-model=reminder.type :id="'reminder_' + reminder.id + '_type'">
                                            <option v-for="reminderType in reminderTypes">{{ reminderType }}</option>
                                        </select>
                                    </template>
                                </bordered-input>

                                <button @click="deleteReminder(index)" class="cu-btn"><i class="fa fa-trash"></i></button>
                            </div>

                            <div class="tw-flex">
                                <bordered-input>
                                    <template #label>
                                        <label :for="'reminder_' + reminder.id + '_remind_date'">Erinnerungsdatum</label>
                                    </template>
                                    <template #input>
                                        <input 
                                            @input="dirtyReminders()"
                                            :id="'reminder_' + reminder.id + '_remind_date'"
                                            type="date"
                                            v-model="reminder.remind_date">
                                    </template>
                                </bordered-input>
                            </div>

                            <div class="tw-flex tw-gap-2">
                                <bordered-input>
                                    <template #label>
                                        <label :for="'reminder_' + reminder.id + '_reminded_at_date'">Wurde erinnert am</label>
                                    </template>
                                    <template #input>
                                        <input 
                                            @input="dirtyReminders()"
                                            :id="'reminder_' + reminder.id + '_reminded_at_date'"
                                            type="date"
                                            v-model="reminder.reminded_at_date">
                                    </template>
                                </bordered-input>
                                <bordered-input>
                                    <template #label>
                                        <label :for="'reminder_' + reminder.id + '_reminded_at_time'">zur Uhrzeit</label>
                                    </template>
                                    <template #input>
                                        <input 
                                            @input="dirtyReminders()"
                                            :id="'reminder_' + reminder.id + '_reminded_at_time'"
                                            type="time"
                                            v-model="reminder.reminded_at_time">
                                    </template>
                                </bordered-input>
                            </div>
                        </div>

                        <div class="tw-flex tw-gap-2">
                            <button @click="addReminder()" class="cu-btn-success">Neue Erinnerung erstellen <i class="fa fa-plus"></i></button>
                            <button v-if="remindersDirtyFlag" @click="saveReminders()" class="cu-btn">Speichern</button>
                            <button v-if="remindersDirtyFlag" @click="abortRemindersEdit()" class="cu-btn-default">Abbrechen</button>
                        </div>
                    </div>
                </div>

                <div class="cu-panel">
                    <div class="cu-panel-header">Termine</div>
                    <div class="cu-panel-body tw-space-y-6">
                        <div v-for="(appointment, index) in appointmentsFront" class="tw-space-y-3">
                            <div class="tw-flex tw-gap-2">
                                <bordered-input>
                                    <template #label>
                                        <label :for="'appointment_' + appointment.id + '_type'">Typ</label>
                                    </template>
                                    <template #input>
                                        <select @change="dirtyAppointments()" v-model=appointment.type :id="'appointment_' + appointment.id + '_type'">
                                            <option v-for="appointmentType in appointmentTypes">{{ appointmentType }}</option>
                                        </select>
                                    </template>
                                </bordered-input>

                                <button @click="deleteAppointment(index)" class="cu-btn"><i class="fa fa-trash"></i></button>
                            </div>
                            <div class="tw-flex tw-gap-2">
                                <bordered-input>
                                    <template #label>
                                        <label :for="'appointment_' + appointment.id + '_starts_date'">
                                            Startdatum
                                        </label>            
                                    </template>
                                    <template #input>
                                        <input 
                                            @input="dirtyAppointments()"
                                            :id="'appointment_' + appointment.id + '_starts_date'" 
                                            type="date" 
                                            v-model="appointment.startsDate"
                                        >
                                    </template>
                                </bordered-input>
                                <bordered-input>
                                    <template #label>
                                        <label :for="'appointment_' + appointment.id + '_starts_time'">
                                            Uhrzeit
                                        </label>            
                                    </template>
                                    <template #input>
                                        <input 
                                            @input="dirtyAppointments()"
                                            :id="'appointment_' + appointment.id + '_starts_time'" 
                                            type="time" 
                                            v-model="appointment.startsTime"
                                        >
                                    </template>
                                </bordered-input>
                            </div>
                            <div class="tw-flex tw-gap-2">
                                <bordered-input>
                                    <template #label>
                                        <label :for="'appointment_' + appointment.id + '_ends_date'">
                                            Enddatum
                                        </label>            
                                    </template>
                                    <template #input>
                                        <input 
                                            @input="dirtyAppointments()"
                                            :id="'appointment_' + appointment.id + '_ends_date'" 
                                            type="date" 
                                            v-model="appointment.endsDate"
                                        >
                                    </template>
                                </bordered-input>
                                <bordered-input>
                                    <template #label>
                                        <label :for="'appointment_' + appointment.id + '_ends_time'">
                                            Uhrzeit
                                        </label>            
                                    </template>
                                    <template #input>
                                        <input 
                                            @input="dirtyAppointments()"
                                            :id="'appointment_' + appointment.id + '_ends_time'" 
                                            type="time" 
                                            v-model="appointment.endsTime"
                                        >
                                    </template>
                                </bordered-input>
                            </div>
                        </div>
                        <div class="tw-flex tw-gap-2">
                            <button @click="addAppointment()" class="cu-btn-success">Neuen Termin erstellen <i class="fa fa-plus"></i></button>
                            <button v-if="appointmentsDirtyFlag" @click="saveAppointments()" class="cu-btn">Speichern</button>
                            <button v-if="appointmentsDirtyFlag" @click="abortAppointmentsEdit()" class="cu-btn-default">Abbrechen</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-w-1/2 tw-space-y-4">
                <div class="cu-panel">
                    <div class="cu-panel-header">Abteilung</div>
                    <div class="cu-panel-body tw-space-y-6">
                        <div class="tw-space-y-3" v-for="(department, index) in departmentsFront">
                            <div class="tw-flex tw-gap-2">
                                <bordered-input>
                                    <template #label>
                                        <label :for="'department_' + department.id + '_id'">Abteilung</label>
                                    </template>
                                    <template #input>
                                        <select @change="dirtyDepartments()" v-model=department.department_id :id="'department_' + department.id + '_id'">
                                            <option v-for="departmentOption in departmentOptions" :value="departmentOption.id">{{ departmentOption.name }}</option>
                                        </select>
                                    </template>
                                </bordered-input>

                                <button @click="deleteDepartment(index)" class="cu-btn"><i class="fa fa-trash"></i></button>
                            </div>

                            <bordered-input>
                                <template #label>
                                    <label :for="'department_' + department.id + '_status'">Status</label>
                                </template>
                                <template #input>
                                    <select @change="dirtyDepartments()" v-model=department.status :id="'department_' + department.id + '_status'">
                                        <option v-for="departmentType in departmentTypes">{{ departmentType }}</option>
                                    </select>
                                </template>
                            </bordered-input>
                        </div>

                        <div class="tw-flex tw-gap-2">
                            <button @click="addDepartment()" class="cu-btn-success">Neue Abteilungs-Zuordnung erstellen <i class="fa fa-plus"></i></button>
                            <button v-if="departmentsDirtyFlag" @click="saveDepartments()" class="cu-btn">Speichern</button>
                            <button v-if="departmentsDirtyFlag" @click="abortDepartmentsEdit()" class="cu-btn-default">Abbrechen</button>
                        </div>
                    </div>
                </div>

                <div class="cu-panel">
                    <div class="cu-panel-header">Status - aktuell: <span class="tw-text-success-primary">
                        {{ statusOptions[applicationFront.status] }}
                    </span></div>
                    <div class="cu-panel-body tw-space-y-6">
                        <div class="tw-flex tw-gap-2">
                            <button @click="putOnHold()" class="cu-btn-default">
                                <i class="fa fa-snowflake-o"></i> Auf Eis
                            </button>

                            <button @click="backToInbox()" class="cu-btn-default">
                                <i class="fa fa-inbox"></i> Zurück in die Inbox
                            </button>
                        </div>
                        <div class="tw-flex tw-gap-2">
                            <button :disabled="backToDepartmentDepartment == null" @click="backToDepartment()" class="cu-btn-default">
                                <i class="fa fa-undo"></i> Zurück in Abteilung:
                            </button>

                            <bordered-input>
                                <template #label>
                                    <label>Abteilung</label>
                                </template>
                                <template #input>
                                    <select v-model="backToDepartmentDepartment">
                                        <option :value="null">Nicht ausgewählt</option>
                                        
                                        <option v-for="departmentOption in departmentOptions" :value="departmentOption.id">
                                            {{ departmentOption.name }}
                                        </option>
                                    </select>
                                </template>
                            </bordered-input>
                        </div>

                        <a :href="'/applications/admin/api/delete/' + applicationFront.id" class="cu-btn">
                            <i class="tw-ml-2 fa fa-trash"></i> Bewerbung und alle zugehörigen Daten löschen
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BorderedInput from "./Redesign/BorderedInput";
    import axios from "axios";
    import moment, { relativeTimeThreshold } from "moment";

    export default {
        components: {
            BorderedInput,
        },

        props: {
            applicationProp: {
                required: true,
                type: Object,
            },

            applicantProp: {
                required: true,
                type: Object,
            },

            appointmentsProp: {
                required: true,
                type: Array,
            },

            appointmentTypes: {
                required: true,
                type: Array,
            },

            remindersProp: {
                required: true,
                type: Array,
            },

            reminderTypes: {
                required: true,
                type: Array,
            },

            departmentsProp: {
                required: true,
                type: Array,
            },

            departmentTypes: {
                required: true,
                type: Array
            },

            departmentOptions: {
                required: true,
                type: Array
            },

            statusOptions: {
                required: true,
                type: Object
            },

            otherApplications: {
                required: true,
                type: Array
            },
        },

        data() {
            return {
                applicationDirtyFlag: false,
                applicationFront: null,
                applicationBackup: null,

                applicantDirtyFlag: false,
                applicantFront: null,
                applicantBackup: null,

                appointmentsDirtyFlag: false,
                appointmentsFront: null,
                appointmentsBackup: null,

                remindersDirtyFlag: false,
                remindersFront: null,
                remindersBackup: null,

                departmentsDirtyFlag: false,
                departmentsFront: null,
                departmentsBackup: null,

                backToDepartmentDepartment: null,

                errors: [],
            };
        },

        methods: {
            putOnHold: function () {
                let capturedThis = this;

                axios
                    .get("/applications/admin/api/put-on-hold/" + this.applicationFront.id)
                    .then(function (response) {
                        capturedThis.refreshApplication(response.data.application);
                        capturedThis.refreshAppointments(response.data.appointments);
                        capturedThis.refreshReminders(response.data.reminders);
                        capturedThis.refreshDepartments(response.data.departments);
                    })
                    .catch(this.showErrors);
            },

            backToDepartment: function () {
                let capturedThis = this;

                if (this.backToDepartmentDepartment == null) {
                    return;
                }

                axios
                    .post("/applications/admin/api/back-to-department/" + this.applicationFront.id, {
                        "department": this.backToDepartmentDepartment
                    })
                    .then(function (response) {
                        capturedThis.refreshApplication(response.data.application);
                        capturedThis.refreshAppointments(response.data.appointments);
                        capturedThis.refreshReminders(response.data.reminders);
                        capturedThis.refreshDepartments(response.data.departments);
                    })
                    .catch(this.showErrors);
            },

            backToInbox: function () {
                let capturedThis = this;

                axios
                    .get("/applications/admin/api/back-to-inbox/" + this.applicationFront.id)
                    .then(function (response) {
                        capturedThis.refreshApplication(response.data.application);
                        capturedThis.refreshAppointments(response.data.appointments);
                        capturedThis.refreshReminders(response.data.reminders);
                        capturedThis.refreshDepartments(response.data.departments);
                    })
                    .catch(this.showErrors);
            },

            showErrors: function (error) {
                let capturedThis = this;

                if (error.response && error.response.data.errors) {
                    capturedThis.errors = [];
                    Object.entries(error.response.data.errors).forEach(([key, item]) => {
                        capturedThis.errors.push(...item);
                    })
                } else {
                    capturedThis.errors = ["Fehler mit der Netzwerkverbindung."];
                }
            },

            dirtyApplication: function () {
                this.applicationDirtyFlag = true;
            },

            dirtyApplicant: function () {
                this.applicantDirtyFlag = true;
            },

            dirtyAppointments: function () {
                this.appointmentsDirtyFlag = true;
            },

            dirtyReminders: function () {
                this.remindersDirtyFlag = true;
            },

            dirtyDepartments: function () {
                this.departmentsDirtyFlag = true;
            },

            saveApplication: function () {
                let capturedThis = this;

                axios
                    .post("/applications/admin/api/update-application/" + this.applicationFront.id, this.applicationFront)
                    .then(function (response) {
                        capturedThis.refreshApplication(response.data);
                        capturedThis.errors = [];
                    })
                    .catch(this.showErrors);
            },

            saveApplicant: function () {
                let capturedThis = this;

                axios 
                    .post("/applications/admin/api/update-applicant/" + this.applicantFront.id, this.applicantFront)
                    .then(function (response) {
                        capturedThis.applicantDirtyFlag = false;
                        capturedThis.applicantFront = { ...response.data };
                        capturedThis.applicantBackup = { ...response.data };
                        capturedThis.errors = [];
                    })
                    .catch(this.showErrors);
            },

            saveAppointments: function () {
                let capturedThis = this;

                axios 
                    .post("/applications/admin/api/update-appointments/" + this.applicationFront.id, {
                        "appointments": this.appointmentsFront
                    })
                    .then(function (response) {
                        console.log(response.data)
                        capturedThis.refreshAppointments(response.data);

                        capturedThis.errors = [];
                    })
                    .catch(this.showErrors);
            },

            saveReminders: function () {
                let capturedThis = this;

                axios 
                    .post("/applications/admin/api/update-reminders/" + this.applicationFront.id, {
                        "reminders": this.remindersFront
                    })
                    .then(function (response) {
                        capturedThis.refreshReminders(response.data);

                        capturedThis.errors = [];
                    })
                    .catch(this.showErrors);
            },

            saveDepartments: function () {
                let capturedThis = this;

                axios
                    .post("/applications/admin/api/update-departments/" + this.applicationFront.id, {
                        "departments": this.departmentsFront
                    })
                    .then(function (response) {
                        capturedThis.refreshDepartments(response.data);

                        capturedThis.errors = [];
                    })
                    .catch(this.showErrors);
            },

            addAppointment: function () {
                this.appointmentsFront.push({
                    type: this.appointmentTypes[0]
                });
                this.appointmentsDirtyFlag = true;
            },

            addReminder: function () {
                this.remindersFront.push({
                    type: this.reminderTypes[0]
                });
                this.remindersDirtyFlag = true;
            },

            addDepartment: function () {
                this.departmentsFront.push({
                    status: this.departmentTypes[0],
                    department_id: this.departmentOptions[0].id
                });
                this.departmentsDirtyFlag = true;
            },

            deleteAppointment: function (index) {
                this.appointmentsFront.splice(index, 1);
                this.appointmentsDirtyFlag = true;
            },

            deleteReminder: function (index) {
                this.remindersFront.splice(index, 1);
                this.remindersDirtyFlag = true;
            },

            deleteDepartment: function (index) {
                this.departmentsFront.splice(index, 1);
                this.departmentsDirtyFlag = true;
            },

            abortApplicationEdit: function () {
                this.applicationDirtyFlag = false;
                this.applicationFront = { ...this.applicationBackup };
            },

            abortApplicantEdit: function () {
                this.applicantDirtyFlag = false;
                this.applicantFront = { ...this.applicantBackup };
            },

            abortAppointmentsEdit: function () {
                this.appointmentsDirtyFlag = false;
                this.appointmentsFront = [];
                this.appointmentsBackup.forEach(item => {
                    this.appointmentsFront.push({ ...item });
                })
            },

            abortRemindersEdit: function () {
                this.remindersDirtyFlag = false;
                this.remindersFront = [];
                this.remindersBackup.forEach(item => {
                    this.remindersFront.push({ ...item });
                })
            },

            abortDepartmentsEdit: function () {
                this.departmentsDirtyFlag = false;
                this.departmentsFront = [];
                this.departmentsBackup.forEach(item => {
                    this.departmentsFront.push({ ...item });
                })
            },

            refreshAppointments: function (newData) { 
                this.appointmentsDirtyFlag = false;           
                this.appointmentsFront = [];
                this.appointmentsBackup = [];

                newData.forEach(item => {
                    let itemCopy = { ...item };
                
                    let startsDatetime = moment(item.date_starts);
                    itemCopy.startsDate = startsDatetime.format('YYYY-MM-DD');
                    itemCopy.startsTime = startsDatetime.format('HH:mm');

                    let endsDatetime = moment(item.date_ends);
                    itemCopy.endsDate = endsDatetime.format('YYYY-MM-DD');
                    itemCopy.endsTime = endsDatetime.format('HH:mm');

                    this.appointmentsFront.push(itemCopy);
                    this.appointmentsBackup.push({ ...itemCopy });
                })
            },

            refreshReminders: function (newData) {
                this.remindersDirtyFlag = false;
                this.remindersFront = [];
                this.remindersBackup = [];

                newData.forEach(item => {
                    let itemCopy = { ...item };

                    itemCopy.remind_date = moment(itemCopy.remind_date).format('YYYY-MM-DD');
                    if (itemCopy.reminded_at != null) {
                        let remindedAt = moment(itemCopy.reminded_at);
                        itemCopy.reminded_at_date = remindedAt.format('YYYY-MM-DD');
                        itemCopy.reminded_at_time = remindedAt.format('HH:mm');
                    }

                    this.remindersFront.push(itemCopy);
                    this.remindersBackup.push({ ...itemCopy });
                })
            },

            refreshDepartments: function (newData) {
                this.departmentsDirtyFlag = false;
                this.departmentsFront = [];
                this.departmentsBackup = [];

                newData.forEach(item => {
                    let itemCopy = { ...item };

                    this.departmentsFront.push(itemCopy);
                    this.departmentsBackup.push({ ...itemCopy });
                })
            },

            refreshApplication: function (newData) {
                this.applicationDirtyFlag = false;
                if (newData.to_be_rejected_date != null) {
                    newData.to_be_rejected_date = moment(newData.to_be_rejected_date).format('YYYY-MM-DD');
                }
                this.applicationFront = { ...newData };
                this.applicationBackup = { ...newData };
            }
        },

        created() {
            this.applicantFront = { ...this.applicantProp };
            this.applicantBackup = { ...this.applicantProp };

            this.refreshApplication(this.applicationProp);
            this.refreshAppointments(this.appointmentsProp);
            this.refreshReminders(this.remindersProp);
            this.refreshDepartments(this.departmentsProp);
        }
    }
</script>